import React from "react"

export default function MobileOnly({ children }) {
  return <div className="mobile-media">{children}</div>
}
